import { NextResponse } from "next/server";
import { NextRequest } from "next/server";
import { getToken } from "next-auth/jwt";

export const createMiddleware = (appUrl: string) => {
  return async function middleware(req: NextRequest) {
    const token = await getToken({ req, secret: process.env.NEXTAUTH_SECRET });

    if (!token) {
      const signInUrl = new URL(`${process.env.NEXTAUTH_URL}/auth`);
      const callbackUrl = `${appUrl}${req.nextUrl.pathname}${req.nextUrl.search}`;
      signInUrl.searchParams.set("callbackUrl", callbackUrl);

      return NextResponse.redirect(signInUrl);
    }

    return NextResponse.next();
  };
};
